import { useQuery } from "@tanstack/react-query";
import { getNotificationsUnreadCount } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const NEW_NOTIFICATIONS_COUNT_QUERY_KEY = "NEW_NOTIFICATIONS_COUNT";
export const newNotificationsCountKeys = {
  all: [NEW_NOTIFICATIONS_COUNT_QUERY_KEY],
};

export const useNewNotificationsCount = () =>
  useQuery({
    queryKey: newNotificationsCountKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getNotificationsUnreadCount(),
    ),
  });
